import { Record } from 'immutable';
export default Record({
  id: null,
  name: null,
  searchField: '',
  width: null
}, 'TableColumnRecord');